var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "line-graph pega-comment-line",
      attrs: {
        id: "line-" + _vm.rect.id,
        width: _vm.largeX,
        hight: _vm.largeY,
        viewBox: _vm.viewBox,
        "data-test": "comment-line-svg",
      },
    },
    [
      _c("path", {
        attrs: { d: _vm.pointString, "data-test": "comment-line-path" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }